import React, { useState, useEffect } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import {
    Edit2,
    Trash2,
    Search,
    /*
        Grid,
        CheckCircle,
        */
    Image as ImageIcon,
    Package
} from 'react-feather';

// import { Search } from 'react-feather';
/*
import { GiCook } from "react-icons/gi";
import { BiDrink } from "react-icons/bi";
*/
import './Articles.css';

import { all_routes } from '../../../Router/all_routes';
import SessionControl from '../../components/SessionControl/sessioncontrol';
import CheckRestauSelected from '../../components/SessionControl/checkrestauselected';
import axios from 'axios';
// import Select from 'react-select';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { base_api_url } from '../../../environment';
import AddArticles from '../../../core/modals/menus/addarticles';
import ArticleComposition from './compositions';
import CatalogueNav from '../../components/CatalogueNav/CatalogueNav';


/**
 * Composant ArticlesNew - Refonte moderne de la page des produits/articles.
 * Propose une interface card-based pour la gestion des plats et boissons.
 */
const ArticlesNew = () => {
    const MySwal = withReactContent(Swal);
    const route = all_routes;
    const navigate = useNavigate();
    const location = useLocation();
    const devise = JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.devise || JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise;

    // États UI
    const [termeRecherche, setTermeRecherche] = useState('');


    // États données
    const [articles, setArticles] = useState([]);
    const [allRestaurantArticles, setAllRestaurantArticles] = useState([]);
    // const [categorie, setCategorie] = useState([]);
    const [menus, setMenus] = useState([]);

    const [selectedMenu, setSelectedMenu] = useState(null);
    const [selectedArticles, setSelectedArticles] = useState([]);
    // const [selectedCategorie, setSelectedCategorie] = useState(null);
    // const [selectedEtiquette, setSelectedEtiquette] = useState(null);
    // const [selectedDisponibilite, setSelectedDisponibilite] = useState(null);

    // États modal
    const [reload, setReload] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showAddArticleModal, setShowAddArticleModal] = useState(false);
    const [showEditArticleModal, setShowEditArticleModal] = useState(false);
    const [editingArticle, setEditingArticle] = useState(null);
    const [showCompositionModal, setShowCompositionModal] = useState(false);
    const [selectedArticleForComposition, setSelectedArticleForComposition] = useState(null);
    const [pageActuelle, setPageActuelle] = useState(1);
    const [showAddToMenuModal, setShowAddToMenuModal] = useState(false);
    const PAR_PAGE = 15;

    // Get menu ID from URL parameters
    const getMenuIdFromUrl = () => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('menuId');
    };    // --- Fonctions de chargement ---

    const fetchCategories = async () => {
        setLoading(true);
        const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
        try {
            const response = await axios.get(`${base_api_url}api/categorie/${ideresto} `);
            // setCategorie(response.data.categorie);
            console.log("Catégories chargées :", response.data.categorie);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchMenus = async () => {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("user"))?.access_token;
        const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
        try {
            let url = `${base_api_url}api/listMenu/${ideresto}/0`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMenus(response.data.menu);
            console.log("Menus chargés :", response.data.menu);
        } catch (error) {
            console.error("Erreur lors du chargement des menus:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchArticles = async () => {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("user"))?.access_token;
        const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
        try {
            let url = `${base_api_url}api/articleRest/${ideresto}`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            });
            console.log("Réponse API :", response.data);

            let articlesData = response.data.article || [];
            setArticles(articlesData);
            setAllRestaurantArticles(articlesData);
            console.log("Réponse:", response.data.article);

            localStorage.setItem("article", JSON.stringify(articlesData));

            if (response.status === 200 || response.status === 201) {
                if (articlesData.length <= 0) {
                    MySwal.fire({
                        icon: "info",
                        // title: "Aucun article",
                        text: "Vous n'avez pas encore d'articles.",
                        toast: true,
                        position: "bottom-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        customClass: {
                            popup: "pixel-toast",
                        },
                    });
                }
            }
        } catch (error) {
            console.error("Erreur lors du chargement des articles:", error);

            //             let errorTitle = "Erreur de chargement";
            let errorMessage = "Impossible de charger les articles.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 401:
                        //                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Vous allez être redirigé vers la page de connexion.";
                        setTimeout(() => {
                            navigate(route.signin);
                        }, 2000);
                        break;

                    case 404:
                        //                         errorTitle = "Restaurant introuvable";
                        errorMessage = "Aucun article trouvé pour ce restaurant ou le restaurant n'existe pas.";
                        break;

                    case 500:
                        //                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez actualiser la page.";
                        break;

                    default:
                        //                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des articles.";
                }
            } else if (error.request) {
                //                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
            }

            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });

            setArticles([]);
            setAllRestaurantArticles([]);
        } finally {
            setLoading(false);
        }
    };

    // --- Hooks ---

    // Charger les données au montage et au reload
    useEffect(() => {
        fetchArticles();
        fetchMenus();
    }, [reload]);

    // Handle menu selection from URL
    useEffect(() => {
        const menuIdFromUrl = getMenuIdFromUrl();
        if (menuIdFromUrl && menus.length > 0) {
            const menuFromUrl = menus.find(menu => menu.id_menu.toString() === menuIdFromUrl);
            if (menuFromUrl) {
                setSelectedMenu({
                    value: menuFromUrl.id_menu,
                    label: menuFromUrl.nom
                });
            }
        }
    }, [menus, location.search]);

    // Charger les catégories
    useEffect(() => {
        fetchCategories();
    }, []);

    const effectOnModal = () => {
        setReload(!reload);
    };

    const handleManageComposition = (article) => {
        setSelectedArticleForComposition(article);
        setShowCompositionModal(true);
    };

    const handleCompositionUpdate = () => {
        setReload(!reload);
    };



    const getArticlesNotInMenu = (menuId) => {
        return allRestaurantArticles.filter(article =>
            !article.menu?.some(menu => menu.id_menu === menuId)
        );
    };

    const handleAddArticleClick = () => {
        if (selectedMenu) {
            setShowAddToMenuModal(true);
            setShowAddArticleModal(false);
        } else {
            setShowAddArticleModal(true);
            setShowAddToMenuModal(false);
        }
    };

    const toggleSelect = (id) => {
        setSelectedArticles(prev =>
            prev.includes(id) ? prev.filter(a => a !== id) : [...prev, id]
        );
    };

    const handleAddSelected = async () => {
        if (!selectedArticles.length) return;

        const payload = selectedArticles.map(id => ({
            id_article: id,
            prix_contenue: 20,
        }));

        console.log("Selected Articles to Add:", payload);

        const token = JSON.parse(localStorage.getItem("user"))?.access_token;

        try {
            await axios.post(`${base_api_url}api/article/${selectedMenu?.value}`,
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setShowAddToMenuModal(false);
            setSelectedArticles([]);
            setReload(!reload);

            MySwal.fire({
                icon: "success",
                // title: "Enregistrement réussie !",
                text: "Articles ajoutés au menu avec succès.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        } catch (err) {
            console.error("Erreur lors de l'ajout des articles :", err);
            MySwal.fire({
                icon: "error",
                // title: "Erreur lors de l'ajout des articles au menu",
                text: "Veuillez réessayer.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        }
    };

    const handleEditArticle = (article) => {
        console.log("Editing article:", article);
        setEditingArticle(article);
        setShowEditArticleModal(true);
        setShowAddArticleModal(false);
        setShowAddToMenuModal(false);
    };

    /* const handleArticleDispo = async (idArticle) => {
        const token = JSON.parse(localStorage.getItem("user"))?.access_token;
        try {
            const response = await axios.put(`${base_api_url}api/article/${idArticle}/${selectedMenu?.value}`, {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.status === 200 || response.status === 201) {
                const updatedArticle = response.data?.contenue;
                const updatedAvailability = updatedArticle?.disponible;

                const updatedArticles = articles.map(article => {
                    if (article.id_article === idArticle) {
                        return {
                            ...article,
                            disponible: updatedAvailability
                        };
                    }
                    return article;
                });
                setArticles(updatedArticles);

                MySwal.fire({
                    icon: "success",
                    // title: "Disponibilité mise à jour !",
                    text: `L'article a été ${updatedAvailability ? 'rendu disponible' : 'rendu indisponible'} avec succès.`,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });

                setReload(!reload);
                console.log("Disponibilité mise à jour:", response.data);
            }

        } catch (error) {
            console.error("Erreur lors du changement:", error);

            //             let errorTitle = "Erreur de mise à jour";
            let errorMessage = "Impossible de modifier la disponibilité de l'article.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 401:
                        //                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
                        setTimeout(() => {
                            navigate(route.signin);
                        }, 2000);
                        break;

                    case 404:
                        //                         errorTitle = "Article introuvable";
                        errorMessage = "L'article que vous tentez de modifier n'existe plus ou n'est pas dans ce menu.";
                        break;

                    case 403:
                        //                         errorTitle = "Accès refusé";
                        errorMessage = "Vous n'avez pas les permissions nécessaires pour modifier cet article.";
                        break;

                    case 409:
                        //                         errorTitle = "Conflit de données";
                        errorMessage = "Une autre modification est en cours. Veuillez réessayer dans quelques instants.";
                        break;

                    case 422:
                        //                         errorTitle = "Données non valides";
                        errorMessage = errorData?.message || "Les données envoyées ne sont pas valides.";
                        break;

                    case 500:
                        //                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
                        break;

                    case 503:
                        //                         errorTitle = "Service indisponible";
                        errorMessage = "Le service est temporairement indisponible. Veuillez réessayer plus tard.";
                        break;

                    default:
                        //                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite.";
                }
            } else if (error.request) {
                //                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
            }

            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        }
    }; */

    const handleUpdateArticle = async (updatedArticleData) => {
        try {
            console.log("Article updated successfully:", updatedArticleData);

            MySwal.fire({
                icon: "success",
                // title: "Article mis à jour !",
                text: "L'article a été modifié avec succès.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });

            setShowEditArticleModal(false);
            setEditingArticle(null);
            setReload(!reload);

        } catch (error) {
            console.error("Erreur lors de la mise à jour de l'article:", error);
            MySwal.fire({
                icon: "error",
                // title: "Erreur lors de la mise à jour",
                text: "Veuillez réessayer.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        }
    };

    const handleDeleteArticle = async (article) => {
        const result = await MySwal.fire({
            title: 'Êtes-vous sûr ?',
            text: `Voulez-vous vraiment supprimer l'article "${article.nom}" ? Cette action est irréversible !`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6a3d',
            cancelButtonColor: '#94a3b8',
            confirmButtonText: 'Oui, supprimer',
            cancelButtonText: 'Annuler',
            customClass: {
                popup: "pixel-toast-delete",
            }
        });

        if (result.isConfirmed) {
            setLoading(true);
            const token = JSON.parse(localStorage.getItem("user"))?.access_token;
            try {
                // Determine which endpoint to use
                let url;
                let method = 'delete';
                let data = null;

                if (selectedMenu) {
                    // Remove from specific menu
                    url = `${base_api_url}api/article/${article.id_article}/${selectedMenu.value}`;
                } else {
                    // Full delete from restaurant
                    url = `${base_api_url}api/article/delete/${article.id_article}`;
                    method = 'put';
                    data = { is_deleted: 1 };
                }

                if (method === 'put') {
                    await axios.put(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                } else {
                    await axios.delete(url, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                }

                MySwal.fire({
                    icon: "success",
                    text: selectedMenu ? "Article retiré du menu." : "Article supprimé avec succès.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });

                setReload(!reload);
            } catch (error) {
                console.error("Erreur lors de la suppression:", error);
                MySwal.fire({
                    icon: "error",
                    text: "Une erreur est survenue lors de la suppression.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });
            } finally {
                setLoading(false);
            }
        }
    };

    // Filtrage des articles
    let filteredData = articles.filter(item => {
        const searchTerm = termeRecherche.toLowerCase();
        const matchesSearch = !termeRecherche || (
            item.nom?.toLowerCase().includes(searchTerm) ||
            item.prix_unitaire?.toString().includes(termeRecherche) ||
            (item.categorie?.[0]?.nom?.toLowerCase() || "").includes(searchTerm) ||
            (item.etiquette?.toLowerCase() || "").includes(searchTerm)
        );

        const matchesMenu = selectedMenu ?
            item.menu?.some(menu => menu.id_menu === selectedMenu.value) :
            true;

        // const matchesCategorie = selectedCategorie ?
        //     item.categorie?.some(cat => cat.id_categorie === selectedCategorie.value) :
        //     true;

        // const matchesEtiquette = selectedEtiquette ?
        //     (item.etiquette === selectedEtiquette.value) :
        //     true;

        // Filtre de disponibilité
        // let matchesDisponibilite = true;
        // if (selectedDisponibilite) {
        //     if (selectedMenu) {
        //         // Si un menu est sélectionné, vérifier la disponibilité dans ce menu
        //         const menuItem = item.menu?.find(menu => menu.id_menu === selectedMenu.value);
        //         const isAvailable = menuItem ? menuItem.disponible : true;
        //         matchesDisponibilite = selectedDisponibilite.value === 'disponible' ? isAvailable : !isAvailable;
        //     } else {
        //         // Si aucun menu n'est sélectionné, considérer tous les articles comme disponibles
        //         // sauf si on filtre pour "non disponible"
        //         matchesDisponibilite = selectedDisponibilite.value === 'disponible';
        //     }
        // }

        return matchesSearch && matchesMenu /*&& matchesCategorie && matchesEtiquette && matchesDisponibilite*/;
    });

    // Prepare articles data with proper image URLs
    filteredData = filteredData.map((item, index) => ({
        ...item,
        image_url: item.image_url && !item.image_url.startsWith('data:image') ? `${base_api_url}api/recuperer/${item.image_url}` : item.image_url,
        key: index + 1,
        id: item.id_article
    }));

    // Pagination
    const totalPages = Math.max(1, Math.ceil(filteredData.length / PAR_PAGE));
    const pageData = filteredData.slice((pageActuelle - 1) * PAR_PAGE, pageActuelle * PAR_PAGE);

    // Options pour les selects
    /* COMMENTÉ car non utilisé suite au masquage des filtres
    const menuOptions = menus.map(menu => ({
        value: menu.id_menu,
        label: menu.nom
    }));
    
    const categorieOptions = categorie.map(cat => ({
        value: cat.id,
        label: cat.nom
    }));
    
    // Extraire les étiquettes uniques des articles
    const etiquettesUniques = [...new Set(articles
        .map(article => article.etiquette)
        .filter(etiquette => etiquette != null && etiquette !== '')
    )];
    
    const etiquetteOptions = etiquettesUniques.map(etiquette => ({
        value: etiquette,
        label: etiquette
    }));
    
    // Options de disponibilité
    const disponibiliteOptions = [
        { value: 'disponible', label: 'Disponible' },
        { value: 'indisponible', label: 'Non disponible' }
    ];
    */


    // const handleMenuChange = (selectedOption) => {
    //     setSelectedMenu(selectedOption);
    // };

    // const handleCategorieChange = (selectedOption) => {
    //     setSelectedCategorie(selectedOption);
    // };

    // const handleEtiquetteChange = (selectedOption) => {
    //     setSelectedEtiquette(selectedOption);
    // };

    // const handleDisponibiliteChange = (selectedOption) => {
    //     setSelectedDisponibilite(selectedOption);
    // };

    // Reset page on menu change
    useEffect(() => { setPageActuelle(1); }, [selectedMenu]);


    return (
        <div className="page-wrapper">
            <SessionControl
                storageKey="user"
                propsup="email"
                redirectTo={route.signin}
            />
            <CheckRestauSelected
                storageKey="user"
                redirectTo={route.Restaurants}
            />
            <div className="articles-page">
                {/* NAVIGATION CATALOGUE */}
                <CatalogueNav
                    activeTabId="articles"
                    subtitle={selectedMenu ? `Menu: ${selectedMenu.label}` : "Gestion des articles."}
                    addButtonText={selectedMenu ? "Ajouter au menu" : "Ajouter un article"}
                    onAddClick={handleAddArticleClick}
                />

                {/* Barre de recherche */}
                <div className="filters-row">
                    <div className="search-wrapper">
                        <Search className="search-icon" size={18} />
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Rechercher un article par nom, catégorie, étiquette..."
                            value={termeRecherche}
                            onChange={(e) => {
                                setTermeRecherche(e.target.value);
                                setPageActuelle(1);
                            }}
                        />
                    </div>
                </div>


                {/* FILTRES : Recherche et listes déroulantes de filtrage - COMMENTÉ
                <div className="filters-row">
                    <div className="search-wrapper">
                        <Search className="search-icon" size={18} />
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Rechercher un plat ou une boisson..."
                            value={termeRecherche}
                            onChange={(e) => setTermeRecherche(e.target.value)}
                        />
                    </div>

                    <div className="filter-select-wrapper">
                        <Select
                            value={selectedMenu}
                            onChange={handleMenuChange}
                            options={menuOptions}
                            placeholder="Tous les menus"
                            isClearable
                            classNamePrefix="react-select"
                            className="filter-select-react"
                        />
                    </div>

                    <div className="filter-select-wrapper">
                        <Select
                            value={selectedCategorie}
                            onChange={handleCategorieChange}
                            options={categorieOptions}
                            placeholder="Toutes les catégories"
                            isClearable
                            classNamePrefix="react-select"
                            className="filter-select-react"
                        />
                    </div>

                    <div className="filter-select-wrapper">
                        <Select
                            value={selectedEtiquette}
                            onChange={handleEtiquetteChange}
                            options={etiquetteOptions}
                            placeholder="Toutes les étiquettes"
                            isClearable
                            classNamePrefix="react-select"
                            className="filter-select-react"
                        />
                    </div>

                    <div className="filter-select-wrapper">
                        <Select
                            value={selectedDisponibilite}
                            onChange={handleDisponibiliteChange}
                            options={disponibiliteOptions}
                            placeholder="Disponibilité"
                            isClearable
                            classNamePrefix="react-select"
                            className="filter-select-react"
                        />
                    </div>
                </div>
                */}

                {/* LISTE : Affichage des articles sous forme de cartes */}
                <div className="articles-list">
                    {loading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Chargement...</span>
                            </div>
                        </div>
                    ) : filteredData.length === 0 ? (
                        <div className="text-center text-muted py-4">
                            Aucun article trouvé.
                        </div>
                    ) : pageData.map((article) => {
                        const menuItem = selectedMenu ? article.menu?.find(art => art.id_menu == selectedMenu?.value) : null;
                        const isAvailable = menuItem ? menuItem.disponible : true;
                        const isUnavailable = selectedMenu && !isAvailable;

                        return (
                            <div key={article.id} className={`article-card ${isUnavailable ? 'unavailable' : ''}`}>
                                <div className="article-left">
                                    {/* Image ou placeholder */}
                                    <div className="article-image-box">
                                        {article.image_url ? (
                                            <img src={article.image_url} alt={article.nom} />
                                        ) : (
                                            <ImageIcon size={20} />
                                        )}
                                    </div>
                                    <div className="article-info-text">
                                        <span className="article-name">{article.nom}</span>
                                        <div className="article-meta-row">
                                            {article.categorie?.[0] && (
                                                <span className="tag-article">{article.categorie[0].nom}</span>
                                            )}
                                            {article.etiquette && (
                                                <span className="tag-article tag-etiquette">#{article.etiquette}</span>
                                            )}
                                        </div>
                                        <span className="article-price">{article.prix_unitaire} {devise}</span>
                                    </div>
                                </div>

                                <div className="article-right">
                                    <div className={`status-badge ${isAvailable ? 'available' : 'unavailable'}`}>
                                        {isAvailable ? 'Disponible' : 'Indisponible'}
                                    </div>

                                    {/* Actions directes */}
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginLeft: '16px' }}>
                                        <button
                                            className="btn-actions"
                                            title="Modifier"
                                            onClick={() => handleEditArticle(article)}
                                        >
                                            <Edit2 size={16} />
                                        </button>

                                        <button
                                            className="btn-actions"
                                            title="Composition"
                                            onClick={() => handleManageComposition(article)}
                                        >
                                            <Package size={16} />
                                        </button>

                                        {/* {selectedMenu && (
                                            <button
                                                className="btn-actions"
                                                title={isAvailable ? 'Rendre indisponible' : 'Rendre disponible'}
                                                onClick={() => handleArticleDispo(article.id)}
                                            >
                                                {isAvailable ? <EyeOff size={16} /> : <Eye size={16} />}
                                            </button>
                                        )} */}

                                        <button
                                            className="btn-actions delete"
                                            title="Supprimer"
                                            style={{ color: '#ef4444' }}
                                            onClick={() => handleDeleteArticle(article)}
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* PAGINATION */}
                {totalPages > 1 && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginTop: '20px', marginBottom: '8px' }}>
                        <button
                            onClick={() => setPageActuelle(p => Math.max(1, p - 1))}
                            disabled={pageActuelle === 1}
                            style={{ height: '36px', padding: '0 14px', border: '1px solid #e5e7eb', borderRadius: '8px', background: '#fff', color: pageActuelle === 1 ? '#d1d5db' : '#374151', fontSize: '13px', fontWeight: 500, cursor: pageActuelle === 1 ? 'default' : 'pointer', transition: 'background 0.15s' }}
                        >← Préc.</button>

                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(n => n === 1 || n === totalPages || Math.abs(n - pageActuelle) <= 1)
                            .reduce((acc, n, idx, arr) => {
                                if (idx > 0 && n - arr[idx - 1] > 1) acc.push('...');
                                acc.push(n);
                                return acc;
                            }, [])
                            .map((item, idx) =>
                                item === '...' ? (
                                    <span key={`dots-${idx}`} style={{ padding: '0 4px', color: '#9ca3af', fontSize: '13px' }}>…</span>
                                ) : (
                                    <button
                                        key={item}
                                        onClick={() => setPageActuelle(item)}
                                        style={{ width: '36px', height: '36px', border: pageActuelle === item ? '1.5px solid #ff6a3d' : '1px solid #e5e7eb', borderRadius: '8px', background: pageActuelle === item ? '#fff4f0' : '#fff', color: pageActuelle === item ? '#ff6a3d' : '#374151', fontSize: '13px', fontWeight: pageActuelle === item ? 700 : 400, cursor: 'pointer', transition: 'background 0.15s' }}
                                    >{item}</button>
                                )
                            )
                        }

                        <button
                            onClick={() => setPageActuelle(p => Math.min(totalPages, p + 1))}
                            disabled={pageActuelle === totalPages}
                            style={{ height: '36px', padding: '0 14px', border: '1px solid #e5e7eb', borderRadius: '8px', background: '#fff', color: pageActuelle === totalPages ? '#d1d5db' : '#374151', fontSize: '13px', fontWeight: 500, cursor: pageActuelle === totalPages ? 'default' : 'pointer', transition: 'background 0.15s' }}
                        >Suiv. →</button>

                        <span style={{ marginLeft: '8px', fontSize: '12px', color: '#9ca3af' }}>
                            {(pageActuelle - 1) * PAR_PAGE + 1}–{Math.min(pageActuelle * PAR_PAGE, filteredData.length)} / {filteredData.length}
                        </span>
                    </div>
                )}

                {/* MODALS */}
                {showAddArticleModal && (
                    <AddArticles
                        show={showAddArticleModal}
                        onFormSubmit={() => {
                            effectOnModal();
                            setShowAddArticleModal(false);
                        }}
                        onClose={() => setShowAddArticleModal(false)}
                    />
                )}

                {showEditArticleModal && editingArticle && (
                    <AddArticles
                        show={showEditArticleModal}
                        editMode={true}
                        articleData={editingArticle}
                        onFormSubmit={() => {
                            handleUpdateArticle();
                            effectOnModal();
                        }}
                        onClose={() => {
                            setShowEditArticleModal(false);
                            setEditingArticle(null);
                        }}
                    />
                )}

                {/* New Modal for Adding Articles to Menu */}
                {showAddToMenuModal && (
                    <div className="premium-menu-modal-overlay">
                        <div className="premium-menu-modal-container">
                            <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content atm-modal-content">

                                        {/* Header */}
                                        <div className="modal-header atm-modal-header">
                                            <div className="atm-header-title-group">
                                                <h5 className="modal-title atm-modal-title">
                                                    Ajouter au menu
                                                    <span className="atm-menu-name">&ldquo;{selectedMenu?.label}&rdquo;</span>
                                                </h5>
                                                {selectedArticles.length > 0 && (
                                                    <span className="atm-selection-badge">
                                                        {selectedArticles.length} sélectionné{selectedArticles.length > 1 ? 's' : ''}
                                                    </span>
                                                )}
                                            </div>
                                            <button
                                                type="button"
                                                className="atm-close-btn"
                                                onClick={() => { setShowAddToMenuModal(false); setSelectedArticles([]); }}
                                                aria-label="Fermer"
                                            >✕</button>
                                        </div>

                                        {/* Instruction banner */}
                                        <div className="atm-instruction-banner">
                                            <span className="atm-instruction-icon">👆</span>
                                            <span>
                                                Cliquez sur un article pour le sélectionner ou le désélectionner.
                                                Seuls les articles absents de ce menu sont affichés.
                                            </span>
                                        </div>

                                        {/* Body */}
                                        <div className="modal-body atm-modal-body">
                                            {getArticlesNotInMenu(selectedMenu?.value).length === 0 ? (
                                                <div className="atm-empty-state">
                                                    <span className="atm-empty-icon">🎉</span>
                                                    <p>Tous les articles du restaurant sont déjà dans ce menu.</p>
                                                </div>
                                            ) : (
                                                <div className="atm-grid">
                                                    {getArticlesNotInMenu(selectedMenu?.value).map(article => {
                                                        const isSelected = selectedArticles.includes(article.id_article);
                                                        const imgSrc = article.image_url && !article.image_url.startsWith('data:image')
                                                            ? `${base_api_url}api/recuperer/${article.image_url}`
                                                            : article.image_url;
                                                        return (
                                                            <div
                                                                key={article.id_article}
                                                                className={`atm-article-card ${isSelected ? 'atm-selected' : ''}`}
                                                                onClick={() => toggleSelect(article.id_article)}
                                                                role="button"
                                                                aria-pressed={isSelected}
                                                                tabIndex={0}
                                                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSelect(article.id_article); } }}
                                                            >
                                                                {/* Checkmark overlay */}
                                                                <div className={`atm-check-overlay ${isSelected ? 'atm-check-visible' : ''}`}>
                                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                        <path d="M2 7l3.5 3.5L12 3" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                    </svg>
                                                                </div>

                                                                {/* Image */}
                                                                <div className="atm-article-img-wrap">
                                                                    {imgSrc ? (
                                                                        <img src={imgSrc} alt={article.nom} className="atm-article-img" />
                                                                    ) : (
                                                                        <div className="atm-article-img-placeholder">
                                                                            <ImageIcon size={22} />
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* Info */}
                                                                <div className="atm-article-info">
                                                                    <span className="atm-article-name">{article.nom}</span>
                                                                    <span className="atm-article-price">{article.prix_unitaire} {devise}</span>
                                                                    {article.categorie?.[0] && (
                                                                        <span className="atm-article-cat">{article.categorie[0].nom}</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>

                                        {/* Footer */}
                                        <div className="atm-modal-footer">
                                            <button
                                                type="button"
                                                className="btn-premium-cancel"
                                                onClick={() => { setShowAddToMenuModal(false); setSelectedArticles([]); }}
                                            >
                                                Annuler
                                            </button>
                                            <button
                                                className="btn-add-article atm-confirm-btn"
                                                onClick={handleAddSelected}
                                                disabled={!selectedArticles.length}
                                            >
                                                {selectedArticles.length > 0
                                                    ? `Ajouter ${selectedArticles.length} article${selectedArticles.length > 1 ? 's' : ''}`
                                                    : 'Sélectionnez des articles'}
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showCompositionModal && (
                    <ArticleComposition
                        show={showCompositionModal}
                        onClose={() => {
                            setShowCompositionModal(false);
                            setSelectedArticleForComposition(null);
                        }}
                        articleData={selectedArticleForComposition}
                        onCompositionUpdate={handleCompositionUpdate}
                    />
                )}

                {showCompositionModal && (
                    <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
                )}
            </div>
        </div>
    );
};

export default ArticlesNew;
